<template>
  <div class="equityMail-container">
    <div id="equtiyCenter">
      <!-- logo 与 选好物/逛店铺 与 搜索 -->
      <div class="himgWrap">
        <div class="firstInfo">
          <div class="oneTitle">
            <img src="@/assets/images/logo.png" alt="">
          </div>
          <div class="good-store" @click="handleChangeCurrentPageType">
            <div class="good" :class="{activeType: currentPageType === 1}" data-currentpagetype="1">选好物</div>
            <div class="line"></div>
            <div class="store" :class="{activeType: currentPageType === 2}" data-currentpagetype="2">逛店铺</div>
          </div>
          <div class="orderStore">
            <div class="searchWrap">
              <el-input
                v-model="searchInfo"
                :placeholder="currentPageType === 1 ? '搜索你想要找的商品' : '搜索你想要找的店铺'"
                prefix-icon="el-icon-search"
                class="input-with-select"
                :disabled="homeIsSearch === 3"
                :clearable="homeIsSearch !== 3"
              >
                <el-button slot="append" @click="searchGoodStore">搜索</el-button>
              </el-input>
            </div>
          </div>
        </div>
      </div>
      <template v-if="Number(homeIsSearch) === 1">
        <!-- 非搜索状态 -->
        <template v-if="currentPageType === 1">
          <!-- 分类 与 轮播图 -->
          <div class="contentInfo">
            <div class="flexStyh">
              <!-- 分类 -->
              <div class="storeList">
                <div class="title">全部分类</div>
                <!-- 一级分类 -->
                <div class="itemStore">
                  <div
                    class="topStore"
                    v-for="(item,index) of areaList"
                    :key="index"
                    @mouseenter="handleMouseEnter($event, index, item.children)"
                    @mouseleave="handleMouseLeave"
                  >
                    <span class="name">{{ item.className }}</span>
                    <el-icon class="el-icon-arrow-right"></el-icon>
                  </div>
                </div>
                <!-- 二级分类 -->
                <div
                  v-show="showLevel2"
                  class="level-2-container"
                  :style="{
                    top: level2Position.top + 'px',
                    left: level2Position.left + 'px'
                  }"
                  @mouseenter="handleLevel2MouseEnter"
                  @mouseleave="handleLevel2MouseLeave"
                >
                  <div
                    class="level-2-item"
                    v-for="(item, index) of level2List"
                    :key="index"
                    @mouseenter="handleLevel2ItemMouseEnter(index)"
                    @mouseleave="handleLevel2ItemMouseLeave"
                  >
                    <span class="name">{{ item.className }}</span>
                    <el-icon class="el-icon-arrow-right"></el-icon>
                    <!-- 三级分类 -->
                    <div class="level-3-container" v-show="item.isShowLevel3">
                      <span
                        class="level-3-item"
                        v-for="level3 of item.children"
                        :key="level3.classId"
                        @click="handleSearchClass(level3)"
                      >{{ level3.className }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 轮播图 -->
              <div class="carousel">
                <el-carousel
                  trigger="click"
                >
                  <el-carousel-item v-for="item of carouselDatas" :key="item.id">
                    <img :src="item.titleImg" alt="">
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div>
          </div>
          <!-- 限时秒杀 -->
          <FlashSale v-if="ACTIVITY_FLAG" class="flashSale" ref="FlashSale" />
          <!-- 特惠拼团 -->
          <GroupBuying v-if="ACTIVITY_FLAG" class="froupBuying" ref="GroupBuying" />
          <!-- 为你推荐 -->
          <Recommendation class="Recommendation" ref="Recommendation" />
        </template>
        <VisitStores v-else-if="currentPageType === 2" class="VisitStores" ref="VisitStores" />
      </template>
      <!-- 搜索状态 -->
      <SearchGood v-else-if="homeIsSearch === 2" ref="SearchGood" class="SearchGood" @setSearchInfo="handleSetSearchInfo" />
      <SearchClass v-else-if="homeIsSearch === 3" ref="SearchClass" class="SearchClass" @setSearchInfo="handleSetSearchInfo" />
    </div>
  </div>
</template>
<script>
/*global protocol http */
import { mapState, mapMutations } from 'vuex'
// 秒杀组件
import FlashSale from './equityMailComponents/flashSale.vue'
// 拼团组件
import GroupBuying from './equityMailComponents/groupBuying.vue'
// 为你推荐
import Recommendation from './equityMailComponents/recommendation.vue'
// 逛店铺
import VisitStores from './equityMailComponents/visitStores.vue'
// 搜索商品
import SearchGood from './pt/searchPage/searchGood.vue'
// 搜索分类
import SearchClass from './pt/searchPage/searchClass.vue'

export default {
  components: {
    FlashSale,
    GroupBuying,
    Recommendation,
    VisitStores,
    SearchGood,
    SearchClass
  },
  data() {
    return {
      level2Position: { top: 0, left: 0 }, // 二级菜单位置
      hoverTimer: null,
      activeIndex: null, // 激活的一级分类
      isMouseInLevel2: false, // 鼠标是否离开二级菜单
      showLevel2: false,
      currentPageType: 1, // 1-选好物 2-逛店铺
      level2List: [], // 二级列表
      searchInfo: '',
      areaList: [], // 一级列表
      carouselDatas: [], // 轮播图
      chooseStoreId: null,
      shopTitle: '',
      contentList: [],
      goodList: [],
      activeTab: 'ascNew',
      sort: [{
        'direction': 'ASC',
        'property': 'sortId'
      }],
      // 分页相关
      pageData: {
        total: null,
        pageSizes: [10, 20, 30, 40],
        pageSize: 10,
        currentPage: 1
      },
      isNetWrong: false,
      userPrice: 'price', // 当前用户是零售价还是采购价用于排序
      classId: null,
      scrollContainer: null, // 滚动容器
      scrollDebounceTimer: null, // 防抖定时器,
      debounceDelay: 300, // 防抖延迟
      ACTIVITY_FLAG: window.g.ACTIVITY_FLAG
    }
  },
  computed: {
    ...mapState('pt', ['homeIsSearch', 'homeGoodStore'])
  },
  watch: {
    homeIsSearch: function(val) {
      if (val === 1) {
        this.searchInfo = null
      }
    }
  },
  created() {
    this.getSwiperList()
    this.queryAllClass()
    this.currentPageType = this.homeGoodStore // 保存页面状态(选好物/逛店铺)
  },
  mounted() {
    this.$nextTick(() => {
      this.updateLevel2ContainerPosition()
      this.scrollContainer = this.$el
      this.scrollContainer.addEventListener('scroll', this.handleScroll)
    })
  },
  updated() {
    this.$nextTick(() => {
      this.updateLevel2ContainerPosition()
    })
  },
  beforeDestroy() {
    this.scrollContainer.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    ...mapMutations('pt', ['setHomeIsSearch', 'setHomeGoodStore', 'setSearchInfo', 'setSearchClassId', 'setCurrentStoreType']),
    // *************** 滚动逻辑 - 开始 ***************
    handleScroll() {
      clearTimeout(this.scrollDebounceTimer)
      this.scrollDebounceTimer = setTimeout(() => {
        const {scrollTop, clientHeight, scrollHeight} = this.scrollContainer
        const isBottom = scrollTop + clientHeight >= scrollHeight - 10
        if (isBottom && this.$refs.Recommendation) {
          this.$nextTick(() => {
            this.$refs.Recommendation.getCommoditye()
          })
        }
      }, this.debounceDelay)
    },
    // *************** 滚动逻辑 - 结束 ***************
    // *************** 级联逻辑 - 开始 **************
    // 修改二级菜单的位置
    updateLevel2ContainerPosition() {
      const storeList = this.$el.querySelector('.storeList')
      if (storeList) {
        const rect = storeList.getBoundingClientRect()
        this.level2Position.left = rect.width
      }
    },
    // 进入一级分类
    handleMouseEnter(event, index, item) {
      clearTimeout(this.hoverTimer)
      this.activeIndex = index
      this.showLevel2 = true // 显示二级分类
      this.showLevel3 = false // 隐藏三级分类
      const target = event.currentTarget
      const itemStore = this.$el.querySelector('.itemStore')
      const storeList = this.$el.querySelector('.storeList')
      if (target && itemStore && storeList) {
        // 获取目标元素相对于storeList的位置
        // const targetRect = target.getBoundingClientRect()
        // const itemStoreRect = itemStore.getBoundingClientRect()
        const storeListRect = storeList.getBoundingClientRect()
        const scrollTop = itemStore.scrollTop
        const itemOffset = index * 50
        const titleHeight = 65
        let top = titleHeight + itemOffset - scrollTop
        const maxTop = storeListRect.height
        top = Math.min(Math.max(0, top), maxTop)
        this.level2Position.top = top
        this.level2List = (item || []).map(item => {
          return {
            ...item,
            isShowLevel3: false,
            // 如果有三级分类数据，可以在这里初始化
            children: item.children || []
          }
        })
      }
    },
    // 离开一级分类
    handleMouseLeave() {
      this.hoverTimer = setTimeout(() => {
        if (!this.isMouseInLevel2) {
          this.showLevel2 = false
        }
      }, 200)
    },
    // 进入二级容器
    handleLevel2MouseEnter() {
      clearTimeout(this.hoverTimer)
      this.isMouseInLevel2 = true
    },
    // 离开二级容器
    handleLevel2MouseLeave() {
      this.isMouseInLevel2 = false
      this.hoverTimer = setTimeout(() => {
        this.showLevel2 = false
        this.level2List.forEach((item) => {
          item.isShowLevel3 = false
        })
      }, 200)
    },
    // 进入二级的菜单项
    handleLevel2ItemMouseEnter(index) {
      clearTimeout(this.hoverTimer)
      this.level2List.forEach((item, i) => {
        item.isShowLevel3 = i === index
      })
    },
    // 离开二级菜单项
    handleLevel2ItemMouseLeave() {

    },
    // *************** 级联逻辑 - 结束 **************
    // *************** 页面逻辑 - 开始 **************

    // 回显商品搜索
    handleSetSearchInfo(val) {
      this.searchInfo = val
    },

    // 改变当前页面(选好物/逛店铺)
    handleChangeCurrentPageType(e) {
      this.setCurrentStoreType(null)
      this.searchInfo = ''
      this.setHomeIsSearch(1) // 重置首页搜索状态 - 非搜素
      if (!Number(e.target.dataset.currentpagetype)) {
        return
      }
      this.currentPageType = Number(e.target.dataset.currentpagetype)
      this.setHomeGoodStore(Number(e.target.dataset.currentpagetype)) // 保存当前状态(选好物/逛店铺)
    },
    // 搜索分类
    handleSearchClass(level3) {
      this.handleLevel2MouseLeave() // 移除分类菜单展开状态
      this.setHomeIsSearch(3) // 切换为搜索分类
      this.$nextTick(() => {
        // this.$refs.SearchClass.loadData()
        // this.$refs.SearchClass.classId = level3.classId
        this.searchInfo = level3.className
        this.classId = level3.classId
        this.setSearchInfo(this.searchInfo) // 保存搜索信息
        this.setSearchClassId(this.classId) // 保存分类id
      })
    },
    // 搜索商品/店铺
    searchGoodStore() {
      if (this.currentPageType === 1) { // 查询商品
        // 搜索分类
        if (this.homeIsSearch === 3) {
          this.$nextTick(() => {
            if (this.$refs.SearchClass) {
              // this.$refs.SearchClass.classId = this.classId
              // this.$refs.SearchClass.searchInfo = this.searchInfo
              this.$refs.SearchClass.loadData()
              this.setSearchInfo(this.searchInfo) // 保存搜索信息
              this.setSearchClassId(this.classId) // 保存分类id
            }
          })
          return
        }
        // 搜索商品
        this.setHomeIsSearch(2) // 切换为搜索商品
        this.$nextTick(() => {
          if (this.$refs.SearchGood) {
            this.$refs.SearchGood.searchInfo = this.searchInfo
            this.$refs.SearchGood.loadData()
            this.setSearchInfo(this.searchInfo) // 保存搜索信息
            this.setSearchClassId(null) // 清空清空分类id
          }
        })
      } else { // 查询店铺
        this.$refs.VisitStores.storeName = this.searchInfo
        this.$refs.VisitStores.queryAllStore()
      }
    },
    // *************** 页面逻辑 - 结束 **************
    // *************** 接口请求 - 开始 **************
    // 获取轮播图
    getSwiperList() {
      const apiObj = JSON.parse(JSON.stringify(protocol.param_pt_getContentTitleList))
      apiObj.param = {
        columnId: 388,
        page: 0,
        size: 99999
      }
      http.getRes(apiObj).then(response => {
        const { code, message, value } = response.data
        if (Number(code) === 0) {
          this.carouselDatas = value.content
        } else {
          this.$message.warning(message)
        }
      })
    },
    // 获取所有分类
    queryAllClass() {
      const apiObj = JSON.parse(JSON.stringify(protocol.param_pt_findClassification))
      apiObj.param = {
        level: 1
      }
      http.postFrontMall(apiObj).then((res) => {
        const { code, message, value } = res.data
        if (Number(code) === 0) {
          this.areaList = value
        } else {
          this.$message.warning(message)
        }
      })
    },
    // *************** 接口请求 - 结束 **************
  }
}
</script>
<style scoped lang="scss">
  .equityMail-container {
    height: calc(100vh - 40px);
    overflow-y: scroll;
    overflow-x: hidden;
    #equtiyCenter{
      position: relative;
      background: #F4F4F4;
      min-height: calc(100vh - 40px);
      display: flow-root;
      .himgWrap{
        width: 1200px;
        margin: 10px auto 0;
        height: 87px;
        background: transparent;
        .firstInfo{
          width: 1200px;
          height: 100%;
          display: flex;
          gap: 34px;
          align-items: center;
          margin: 0 auto;
          justify-content: center;
          position: relative;
          .oneTitle{
            position: absolute;
            left: 0;
            top: 20px;
            // width: 198px;
            width: 47px;
            height: 47px;
            background: #D9D9D9;
            line-height: 47px;
            text-align: center;
            font-size: 18px;
            font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
            font-weight: 500;
            color: #333333;
            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }
        }
        .good-store {
          display: flex;
          align-items: center;
          gap: 14px;
          height: 47px;
          color: #999999;
          font-size: 18px;
          font-weight: 700;
          .activeType {
            color: #1571DB;
          }
          .good {
            cursor: pointer;
          }
          .line {
            width: 1px;
            height: 16px;
            background: #cccccc;
          }
          .store {
            cursor: pointer;
          }
        }
        .orderStore{
          display: flex;
          justify-content: flex-end;
          .searchWrap {
            /deep/ .el-input {
              width: 630px;
              .el-input__inner{
                height: 44px;
                border-radius: 4px 4px 4px 4px;
                background:transparent;
                border: 1px solid #A5A6AC;
                font-size: 12px;
                font-family: Alibaba PuHuiTi-Regular, Alibaba PuHuiTi;
                font-weight: 400;
                color: #999999;
                box-sizing: border-box;
              }
              .el-input__icon {
                line-height: 44px;
                font-size: 12px;
              }
              .el-input-group__append{
                width: 104px;
                height: 44px;
                border:none;
                padding: 0;
                background: #1571DB;
                font-size: 16px;
                text-align: center;
                .el-button {
                  span {
                    color: #FFFFFF;
                  }
                }
              }
            }
          }
          .btns{
            cursor: pointer;
            display: inline-block;
            width: 83px;
            height: 32px;
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #D9D9D9;
            // box-sizing: border-box;
            text-align: center;
            font-size: 16px;
            font-family: Alibaba PuHuiTi-Regular, Alibaba PuHuiTi;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 33px;
            margin-left:16px;
          }
        }
      }
      .contentInfo{
        width: 1200px;
        margin: 0 auto;
        position: relative;
        border-radius: 2px 0 0 2px;
        .flexStyh{
          display: flex;
          height: 450px;
          background: #FFFFFF;
          border-radius: 2px 0 0 2px;
          .storeList{
            width: 232px;
            display: flex;
            flex-direction: column;
            position: relative;
            .title{
              height: 65px;
              background: transparent;
              font-size: 18px;
              font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
              font-weight: 500;
              color: #333333;
              line-height: 65px;
              padding-left: 20px;
              border-bottom: 1px solid #cccccc;
            }
            // 分类列表
            .itemStore{
              flex: 1;
              background: transparent;
              overflow-x: hidden;
              overflow-y: scroll;
              // 隐藏滚动条
              scrollbar-width: none; /* Firefox */
              -ms-overflow-style: none; /* IE 和 Edge */
              // 隐藏滚动条
              &::-webkit-scrollbar {
                  display: none; /* Chrome, Safari, Opera */
              }
              // 每一项分类
              .topStore{
                height: 50px;
                width: 100%;
                cursor: pointer;
                line-height: 60px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                &:hover {

                }
                .name{
                  font-size: 16px;
                  color: #333333;
                  font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
                  font-weight: 500;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis; // 超出以省略号显示
                  margin-left: 20px;
                }
                /deep/ .el-icon-arrow-right {
                  font-size: 16px;
                  color: #666666;
                  font-weight: 700;
                  margin-right: 10px;
                }
              }
            }
            .level-2-container {
              position: absolute;
              width: 232px;
              background: #ffffff;
              top: 0;
              left: 232px;
              z-index: 999;
              .level-2-item {
                position: relative;
                width: 100%;
                height: 40px;
                line-height: 40px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                cursor: pointer;
                .name{
                  font-size: 16px;
                  color: #333333;
                  font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
                  font-weight: 500;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis; // 超出以省略号显示
                  margin-left: 20px;
                }
                /deep/ .el-icon-arrow-right {
                  font-size: 16px;
                  color: #666666;
                  font-weight: 700;
                  margin-right: 10px;
                }
                .level-3-container {
                  position: absolute;
                  top: 0;
                  left: 100%;
                  width: 200px;
                  display: flex;
                  flex-direction: column;
                  background: #ffffff;
                  .level-3-item {
                    text-align: center;
                    width: 100%;
                    color: #333333;
                    font-size: 16px;
                    font-weight: 500;
                  }
                }
              }
            }
          }
          .carousel {
            flex: 1;
            background: #D9D9D9;
            /deep/ .el-carousel {
              height: 100%;
              .el-carousel__container {
                height: 100%;
                .el-carousel__arrow {
                  .el-icon-arrow-left {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    font-size: 30px;
                  }
                  .el-icon-arrow-right {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    font-size: 30px;
                  }
                }
              }
            }
            .el-carousel__item img {
              width: 100%;
              height: 100%;
            }

            .el-carousel__item:nth-child(2n) {
              background-color: #99a9bf;
            }
            .el-carousel__item:nth-child(2n+1) {
              background-color: #d3dce6;
            }
          }
        }
      }
      .rightCon{
        width:calc(100% - 204px);
        .listWrap{
          .sortTitle{
            display: flex;
            justify-content: space-between;
            .leftTitle{
              display: flex;
              align-items: center;
              padding-left:8px;
              box-sizing: border-box;
              width: 140px;
              height: 32px;
              background: linear-gradient(90deg, rgba(194,154,96,0.58) 0%, rgba(50,50,55,0.22) 100%);
              .imgInfo{
                width: 24px;
                height: 24px;
                margin-right: 4px;
              }
              .titles{
                font-size: 16px;
                font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
                font-weight: 500;
                color: #C89955;
              }
            }
            .sortWrap{
              display: flex;
              align-items: center;
              p{
                margin-right: 40px;
                font-size: 12px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 14px;
                position: relative;
                cursor: pointer;
              }
              /deep/.el-icon-caret-top{
                position: absolute;
                font-size:12px;
                top: -2px;
                color: #FFFFFF;
              }
              /deep/.el-icon-caret-bottom{
                position: absolute;
                font-size:12px;
                bottom: -3px;
                color: #FFFFFF;
              }
              /deep/.el-icon-d-arrow-right{
                color:#fff;
              }
              .activeSort{
                color:#E4CA91;
              }
            }
          }
          .goodList{
            display: flex;
            flex-wrap: wrap;
            position: relative;
            .goodStys{
              margin-right: 24px;
            }
            .maTop{
              margin-top:30px;
            }
            .goodItem{
              margin-top:22px;
              width: 180px;
              height: 278px;
              background: #3B3E4E;
              padding:10px;
              box-sizing: border-box;
              cursor: pointer;
              position: relative;
            }
            .goodStys:nth-child(5n){
              margin-right: 0px;
            }
            .goodStys:nth-child(6n)::after,.goodStys:nth-child(1)::after{
                content:'';
                position: absolute;
                left:0;
                  width:995px;
                  height: 2px;
                  background: #3B3E4E;
                  margin-top:25px;
              }
            .goodImg{
              width: 158px;
              height: 158px;
            }
              .saleAll{
              position: absolute;
              width: 52%;
              max-height: 46%;
              right: 10px;
              top: 88px;
            }
            .name{
              margin-top:10px;
              height: 32px;
              color: #FFFFFF;
              font-size: 14px;
              font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
              font-weight: 500;
              line-height: 16px;
              word-break: break-all;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2; /* 这里是超出几行省略 */
              overflow: hidden;
            }
            .goodItem:hover {
              transform: translateY(-4px);
              transition-duration:1s;
              box-shadow: 2px 2px 2px 2px #171B2F;
              .name{
                color: #E4CA91;
              }
            }
            .marketPWrap{
              margin-top:14px;
              font-size: 14px;
              font-family: ITC Avant Garde Gothic Pro-Medium, ITC Avant Garde Gothic Pro;
              font-weight: 500;
              color: #9A9A9A;
              line-height: 19px;
              span{
                color: #9A9A9A;
                text-decoration: line-through;
              }
            }
            .priceWrap{
              margin-top:5px;
              font-size: 14px;
              font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
              font-weight: 500;
              color: #B0B8DB;
              line-height: 19px;
              position: relative;
              i{
                font-style: normal;
                color:#9A9A9A;
              }
              .utils{
                margin-left:2px;
                font-size: 12px;
                font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
                font-weight: 500;
                color: #FFFFFF;
              }
              .yutil{
                font-size: 14px;
                font-family: ITC Avant Garde Gothic Pro-Demi, ITC Avant Garde Gothic Pro;
                font-weight: normal;
                color: #E4CA91;
              }
              .price{
                font-size: 20px;
                font-family: ITC Avant Garde Gothic Pro-Demi, ITC Avant Garde Gothic Pro;
                font-weight: normal;
                color: #E4CA91;
              }
              .newIsty{
                position: absolute;
                right:-10px;
                padding:0 6px 0 24px;
                height: 18px;
                background:linear-gradient(65deg, transparent 18px,#E4CA91 0);
                font-size: 12px;
                font-family: "Alibaba PuHuiTi-Medium, Alibaba PuHuiTi";
                font-weight: 500;
                color: #382804;
                line-height: 18px;
              }
            }
            .twoStyleRow{
              width: 100%;
              height:30px;
              position: absolute;
              top: 280px;
              .bottomLine{
                width:100%;
                height: 2px;
                background: #3B3E4E;
                margin-top:28px;
              }
            }
          }
        }
      }
    }
  }
</style>

